import React from 'react';
import { useAuth } from '../../context/AuthContext';
import Layout from '@components/Layout';
import Tour from '@components/Tour';
import { dashboardTourSteps } from '@utils/TourSteps/Dashboard';
import SevenDays from '@components/charts/SevenDays'; // your previous 7-day chart
import VendorKpiCards from '@components/charts/VendorKpiCards';

function ParticipantDashboard() {
  const { globalUser } = useAuth();

  return (
    <>
      {/* Example: keep breadcrumbs outside in Dashboard wrapper */}
      <div className='row'>
        {/* KPI cards */}
        <VendorKpiCards uid={globalUser?.uid} />
      </div>

      {/* Example charts below */}
      <div className='row mt-4'>
        <div className='col-xl-6 mb-4'>
          <SevenDays
            uid={globalUser?.uid}
            kind='products'
            title='Products — Click-throughs (Last 7 Days)'
            maxSeries={4}
          />
        </div>
        <div className='col-xl-6'>
          <SevenDays
            uid={globalUser?.uid}
            kind='adverts'
            title='Adverts — Click-throughs (Last 7 Days)'
            maxSeries={4}
          />
        </div>
      </div>
    </>
  );
}

export default ParticipantDashboard;
